import { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicFormNew';
import { IDelivery, IDeliveryPOColumn } from '../../Models/Delivery';
import { useNavigate, useParams } from 'react-router-dom';
import { PATHS } from '../../utils/constant';
import { TransactionContext } from '../../contexts/TransactionContext';
import { TColumn, TStepsProps } from '../../Models/common';
import { NotificationContext } from '../../contexts/NotificationContext';
import { Edit, Visibility } from '@mui/icons-material';
import DeliveryLineDetails, { CREATE_DELIVERY_CONFIG } from './UpdateDeliveryLineDetails';
import { getDelivery, updateDeliveryStatus } from '../../services/Transactions';
import useService from '../../hooks/useService';
import ConfirmModal from '../Modals/ConfirmModal';
import { TCommerceSku, TLineItem } from '../../Models/PhysicalOrder';
import StepNavigation from '../custom/StepNavigation';
import EditOffOutlinedIcon from '@mui/icons-material/EditOffOutlined';
import { formatDate } from '../../utils/helpers';

export const PO_LINE_COLUMNS: GridColDef<TLineItem>[] = [

    // {
    //     field: "id",
    //     headerName: 'Id',
    // },
    {
        field: "serialNumber",
        headerName: 'Serial Number',
    },
    {
        field: "orderType",
        headerName: 'Order Type',
    },
    {
        field: "productId",
        headerName: 'Product Id',
    },
    {
        field: "productName",
        headerName: 'Product Name',
        renderCell: (params) => (params.row.product as TCommerceSku).product_name
    },
    {
        field: "metalType",
        headerName: 'Metal Type',
    }
]

export type IDeliveryCol = IDelivery & {
    actions: any;
}

export const DELIVERY_LINE_ITEM_COLUMN: TColumn<IDeliveryCol>[] = [
    {
        field: "actions",
        headerName: 'Action',
    },
    {
        field: "id",
        headerName: 'ID',
    },
    {
        field: "deliveryType",
        headerName: 'Delivery Type',
        minWidth: 150
    },
    {
        field: "status",
        headerName: 'Delivery Status',
        minWidth: 120
    },
    {
        field: "transporter",
        headerName: 'Transporter',
    },
    {
        field: "shipmentDate",
        headerName: 'Shipment Date',
        minWidth: 130
    },
    // {
    //     field: "deliveryMethod",
    //     headerName: 'Delivery Method',
    // },
    // {
    //     field: "direction",
    //     headerName: 'Direction',
    //     minWidth: 100
    // },
    {
        field: "exciseInvoiceNumber",
        headerName: 'Excise Invoice Number',
        minWidth: 200
    },
    {
        field: "awbNumber",
        headerName: 'Tracking Number',
        minWidth: 200
    },
    // {
    //     field: "shippingCharge",
    //     headerName: 'Shipping Charge',
    //     minWidth: 260
    // },
    // {
    //     field: "tax",
    //     headerName: 'Tax',
    //     minWidth: 100
    // },
    // {
    //     field: "serialNumbers",
    //     headerName: 'Serial Numbers',
    //     minWidth: 200
    // },
    {
        field: "remarks",
        headerName: 'Remarks',
        minWidth: 160
    }
]

const Delivery = (props: TStepsProps) => {
    const { path, nextButtonLable, nextSection, prevSection } = props
    const navigate = useNavigate()
    const { capturedSteps } = useContext(TransactionContext)
    const { notify } = useContext(NotificationContext)
    const { id } = useParams()

    const redirectToIncompleteStep = () => {
        if (prevSection && !capturedSteps.includes(prevSection)) {
            goToPrevSection()
        }
    }

    const goToNextSection = () => {
        if (!capturedSteps.includes('DELIVERY'))
            return notify('Complete Delivery first.', 'error')

        if (id) navigate(path + '/' + id + '?section=' + nextSection)
        else navigate(path + '?section=' + nextSection)
    }

    const goToPrevSection = () => {
        if (id) navigate(path + '/' + id + '?section=' + prevSection)
        else navigate(path + '?section=' + prevSection)
    }

    useEffect(() => {
        redirectToIncompleteStep()
    }, [])

    return (
        <div style={{ padding: '0 10px' }}>
            <CreateDelivery goToNextSection={goToNextSection} />
            <div style={{ marginTop: '20px' }}>
                <StepNavigation
                    capturedSteps={capturedSteps}
                    currentSection='DELIVERY'
                    goToNextSection={goToNextSection}
                    nextButtonLable={nextButtonLable}
                    goToPrevSection={goToPrevSection}
                    prevSection={prevSection}
                />
            </div>
        </div>
    )
}

export default Delivery


export const CreateDelivery = (props: { goToNextSection: () => any }) => {
    const { goToNextSection } = props
    const [selectedLines, setSelectedLines] = useState<string[]>([])
    const { physicalOrder, lineItems, deliveryData, transactionInfo: { globalTransactionNumber, status: transactionStatus, transactionType }, setCapturedSteps } = useContext(TransactionContext)
    const [showDeliveryForm, setShowDeliveryForm] = useState<boolean | string>(false)
    const [showDeliveryConformation, setShowDeliveryConformation] = useState<boolean | string>(false)
    const { notify } = useContext(NotificationContext)
    const { execute } = useService()
    const [forceNavigate, setForceNavigate] = useState(false);


    const lineSelectHandler = (selectionModel: GridRowSelectionModel) => {
        setSelectedLines(selectionModel as string[])
    }

    const getPOColumns = () => {
        return PO_LINE_COLUMNS.map(field => {
            return {
                ...field,
                minWidth: 200
            }
        })
    }

    const getDeliveryItemColumns = () => {
        return DELIVERY_LINE_ITEM_COLUMN.map(column => {
            const row: GridColDef<IDeliveryCol> = {
                ...column,
                valueFormatter: (params) => {
                    if (params.field === 'shipmentDate' && params.value) {
                        return formatDate(new Date(params.value));
                    }
                    return params.value;
                }
            }
            switch (column.field) {
                case "actions":
                    row.renderCell = (params) => {
                        return <IconButton >
                        {params.row.status !== 'CONFIRMED' ? <Edit onClick={() => setShowDeliveryConformation(params.id as string)} /> : <EditOffOutlinedIcon/>}
                        </IconButton>
                    }
                    break;
            }
            return row
        })
    }

    const poDetailRow = () => {
        let arr: any[] = []
        let obj: any = {}
        // obj={"skuID":[1,2,3]}
        deliveryData.forEach((delivery) => {
            delivery.deliverables.forEach((deliverable) => {
                if (obj[deliverable.skuId]) {
                    obj[deliverable.skuId] = [...obj[deliverable.skuId], ...deliverable.serialNumbers]
                } else {
                    obj[deliverable.skuId] = deliverable.serialNumbers
                }
            })
        })

        physicalOrder?.lineItems?.forEach((lineItem) => {
            let sNo: any[] = lineItem.serialNumbers && lineItem.serialNumbers !== "" ? JSON.parse(lineItem.serialNumbers) : [];

            for (let i = 0; i < sNo.length; i++) {
                if (!(obj[lineItem.productId] && obj[lineItem.productId].includes(String(sNo[i])))) {
                    arr.push({ ...lineItem, serialNumber: sNo[i], id: lineItem.id + "_" + sNo[i] })
                }
            }
            if (!sNo.length) {
                if (!obj[lineItem.productId]) { arr.push({ ...lineItem, serialNumber: "1" }) }
            }
        })
        return arr
    }


    useEffect(() => {
        fetchDeliveryDetail()
    }, [])

    const fetchDeliveryDetail = async () => {
        const { error } = await execute(() => getDelivery({ globalTransactionNumber, transactionType }))
        if (error === null) {
            notify('Delivery fetch successfully')
        }
    }

    const closeDeliveryForm = () => {
        setShowDeliveryForm(false)
        setSelectedLines([])
    }
    const handleCloseConformation = () => {
        setShowDeliveryConformation(false)
    }

    const handleConfirmStatus = async () => {
        const { error } = await execute(() => updateDeliveryStatus({ globalTransactionNumber, transactionType, id: showDeliveryConformation as string, status: "confirmed" }))

        if (error === null) {
            await execute(() => getDelivery({ globalTransactionNumber, transactionType }))
            notify('Delivery confirmed successfully')
            if (!poDetailRow().length) {
                setCapturedSteps(prev => ([...prev, 'DELIVERY']))
                setForceNavigate(true)
            }
        }
    }

    useEffect(()=>{
        if( forceNavigate ){
            goToNextSection()
        }
    },[forceNavigate])
    

    return (
        <>
            <div>
                <div >
                    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 0', color: '#7f7d76' }}>Delivery Line</Title>
                        <Table
                            fixHeight={300}
                            rowSelectionModel={selectedLines}
                            checkboxSelection
                            onRowSelectionModelChange={lineSelectHandler}
                            columns={getPOColumns()}
                            rows={poDetailRow()}
                            getRowClassName={(params) => selectedLines.includes(params.id as string) ? 'selected_row' : ''}
                            slotProps={{ row: { style: { cursor: 'pointer' } } }}
                        />
                </div>
                <div style={{ marginTop: '15px' }}>
                    <Button variant='outlined' color='secondary' onClick={() => {
                        if (!selectedLines.length) return notify('Add delivery Item first.', 'error')
                        setShowDeliveryForm(true)
                    }}>{'Create Delivery'}</Button>
                </div>

                <div style={{ overflow: 'auto' }}>
                    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 0', color: '#7f7d76' }}>Delivery field</Title>
                    <Table
                        columns={getDeliveryItemColumns()}
                        rows={deliveryData}
                    />
                </div>
            </div>
            {Boolean(showDeliveryForm) &&
                <DeliveryLineDetails lineIds={selectedLines} closeDeliveryForm={closeDeliveryForm} deliveryState={typeof showDeliveryForm === 'string' ? showDeliveryForm : ''} />}

            {Boolean(showDeliveryConformation) && <ConfirmModal title={"confirm Delivery Status"} text={'Are you sure you need to confirm the Delivery'} handleConfirm={handleConfirmStatus} onClose={handleCloseConformation} open={Boolean(showDeliveryConformation)} />}
        </>
    )
}
